import Link from 'next/link'
import { FeedItem } from '@knocklabs/client'
import { Body, BodyColor, BodySize, BodyType } from '~/scalis-components/core/typography'
import { getRichLinkHref, isNotificationVariableWithLink } from '../navbar-notifications-drawer-item.utils'

export const getNotificationRichDescription = (notification: FeedItem): React.ReactNode => {
  if (!notification.data?.rawDescription) {
    return notification.data?.description
  }

  const parts = notification.data.rawDescription.split(/({{[^}]+}})/g)

  return parts.map((part: string, index: number) => {
    const match = part.match(/{{([^}]+)}}/)
    if (match) {
      const variableName = match[1]

      if (isNotificationVariableWithLink(variableName)) {
        const value = notification.data?.[variableName]
        if (!value) return part

        return (
          <Link
            key={index}
            href={getRichLinkHref(variableName, notification)}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Body
              color={BodyColor.brandPrimary}
              type={BodyType.emphasys}
              className='inline hover:underline'
              size={BodySize.small}
            >
              {value}
            </Body>
          </Link>
        )
      }

      return notification.data?.[variableName]
    }

    return part
  })
}
